import { motion } from "framer-motion";

type Client = {
  id: string;
  name: string;
  logoUrl: string | null;
};

const ClientsCarousel = ({ clients }: { clients: Client[] }) => {
  // Duplicate the list to create seamless infinite loop
  const doubled = [...clients, ...clients];

  return (
    <section className="py-20 relative overflow-hidden border-y border-white/5">
      <div className="container mb-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <span className="text-primary font-bold tracking-widest uppercase text-sm mb-4 block">Our Clients</span>
          <h2 className="text-4xl md:text-5xl font-black mb-4">TRUSTED BY BRANDS</h2>
          <p className="text-text-muted max-w-xl mx-auto">
            We're proud to work with amazing companies across industries.
          </p>
        </motion.div>
      </div>

      {/* Fade edges */}
      <div className="absolute left-0 top-0 h-full w-32 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 h-full w-32 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />

      {/* Infinite scroll track */}
      <div className="flex overflow-hidden">
        <motion.div
          className="flex gap-12 items-center shrink-0"
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            duration: Math.max(10, clients.length * 3),
            ease: "linear",
            repeat: Infinity,
          }}
        >
          {doubled.map((client, i) => (
            <div
              key={`${client.id}-${i}`}
              className="flex-shrink-0 h-16 w-36 flex items-center justify-center"
            >
              {client.logoUrl ? (
                <div className="relative w-full h-full grayscale hover:grayscale-0 opacity-50 hover:opacity-100 transition-all duration-300">
                  <img
                    src={client.logoUrl}
                    alt={client.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              ) : (
                <div className="px-6 py-3 bg-white/5 border border-white/10 rounded-xl text-sm font-bold text-text-muted hover:text-white hover:bg-white/10 transition-all duration-300 whitespace-nowrap">
                  {client.name}
                </div>
              )}
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ClientsCarousel;
